<template>
    <span class="ui-inline-jetton">
        <!-- Each side (amount + ticker) is one piece, so a wrapping parent breaks only at the arrow -->
        <span class="ui-inline-swap__side">
            <!-- Split amount on simple table, so we can style int and fractional parts separately -->
            <span v-if="!isMobile && $store.state.transactionViewData === 'simple'" class="ui-inline-jetton__value">
                <tx-amount v-bind:amount="meta.amount_in" v-bind:decimals="meta.decimals_in" />
            </span>
            <span v-else class="ui-inline-jetton__value">
                {{$ton(meta.amount_in, meta.decimals_in, isMobile || round)}}
            </span>
            <!-- Ticker -->
            <ui-link
                v-if="meta.jetton_in_address !== null && meta.jetton_in_address !== 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez'"
                class="ui-inline-jetton__link tx-table-jetton-link-standart"
                v-bind:to="{ name: 'token', params: { address: meta.jetton_in_address }}"
            >
                {{ truncateTicker(displayTicker(meta.symbol_in, meta.jetton_in_address)) || shortenAddress(meta.jetton_in_address) }}
            </ui-link>
            <span v-else>
                GRAM
            </span>
        </span>
        <IconArrowRight class="swap-icon-arrow" />
        <!-- Right side -->
        <span class="ui-inline-swap__side">
            <!-- Split amount on simple table, so we can style int and fractional parts separately -->
            <span v-if="!isMobile && $store.state.transactionViewData === 'simple'" class="ui-inline-jetton__value" v-bind:class="{'ui-inline-jetton--green': !isFailed}">
                <tx-amount v-bind:amount="meta.amount_out" v-bind:decimals="meta.decimals_out" />
            </span>
            <span v-else class="ui-inline-jetton__value" v-bind:class="{'ui-inline-jetton--green': !isFailed}">
                {{$ton(meta.amount_out, meta.decimals_out, isMobile || round)}}
            </span>
            <!-- Ticker -->
            <ui-link
                v-if="meta.jetton_out_address !== null && meta.jetton_out_address !== 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez'"
                class="ui-inline-jetton__link" v-bind:class="{'ui-inline-jetton--green': !isFailed, 'tx-table-jetton-link-standart': isFailed}"
                v-bind:to="{ name: 'token', params: { address: meta.jetton_out_address }}"
            >
                {{ truncateTicker(displayTicker(meta.symbol_out, meta.jetton_out_address)) || shortenAddress(meta.jetton_out_address) }}
            </ui-link>
            <span v-bind:style="isFailed ? '' : 'color: var(--green-bright)'" v-else>
                GRAM
            </span>
        </span>
    </span>
</template>

<script>
import IconArrowRight from '@img/icons/lucide/chevron-right.svg?inline';
import TxAmount from '~/components/address/TxSimpleInlineAmount.vue';
import { displayTicker, truncateTicker } from '../../helpers';

export default {
    props: {
        meta: {
            type: Object,
        },
        round: {
            type: Boolean,
            default: true,
            required: false,
        },
        isFailed: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        truncateTicker,
        displayTicker,
        shortenAddress(address) {
            return address.slice(0, 3) + '...' + address.slice(-3);
        },
    },
    components: {
        TxAmount,
        IconArrowRight,
    },
};
</script>

<style lang="scss">
.ui-inline-swap__side {
    display: inline-flex;
    align-items: center;
}

.swap-icon-arrow {
    opacity: .7;
    width: 10px;
    height: 12px;
    margin: 0 6px;
}
</style>
